import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BuildingIcon } from '../../components/Icons'; 
import { useAuth } from '../../contexts/AuthContext'; 

const AdminLoginPage = () => {
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); 
  const [loading, setLoading] = useState(false); 

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth(); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); 
    setLoading(true); 

    if (email.trim() === '' || password.trim() === '') {
      setError('이메일과 비밀번호를 모두 입력해주세요.');
      setLoading(false);
      return;
    }

    try {
      await login(email, password); 
      // 로그인 후 돌아갈 경로가 state에 있으면 해당 경로로, 없으면 대시보드로
      // 대시보드 기본 경로를 /admin/dashboard에서 /jy-dev/dashboard로 수정
      const from = location.state?.from?.pathname || "/jy-dev/dashboard";
      navigate(from, { replace: true });
    } catch (err) {
      console.error("Admin Login Page Error:", err.message);
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-email') {
        setError('이메일 또는 비밀번호가 잘못되었습니다.');
      } else {
        setError('로그인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      }
    } finally {
      setLoading(false); 
    }
  };

  return (
    <>
      <title>관리자 로그인 - 진양건설</title>
      <meta name="robots" content="noindex, nofollow" />
      <div className="min-h-screen flex items-center justify-center bg-slate-100 dark:bg-slate-900 px-4">
        <div className="w-full max-w-md p-8 space-y-8 bg-white dark:bg-slate-800 rounded-xl shadow-2xl">
          <div className="text-center">
            <BuildingIcon className="mx-auto h-12 w-auto text-sky-600 dark:text-sky-400" />
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-white">관리자 로그인</h2>
          </div>
          {error && <p className="text-center text-red-500 text-sm">{error}</p>}
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="admin-email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">이메일</label>
              <input id="admin-email" name="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-md shadow-sm placeholder-gray-400 dark:placeholder-slate-500 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white" placeholder="admin@example.com"/>
            </div>
            <div>
              <label htmlFor="admin-password"className="block text-sm font-medium text-gray-700 dark:text-gray-300">비밀번호</label>
              <input id="admin-password" name="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-md shadow-sm placeholder-gray-400 dark:placeholder-slate-500 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm bg-white dark:bg-slate-700 text-gray-900 dark:text-white" placeholder="password"/>
            </div>
            <div>
              <button 
                type="submit" 
                disabled={loading}
                className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 dark:focus:ring-offset-slate-800 disabled:opacity-50"
              >
                {loading ? '로그인 중...' : '로그인'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default AdminLoginPage;
